import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FilterType } from "@/types/mainTypes";

type FilterExtras = {
  coordinates: [number, number] | null;
  propertyType: number | null;
  category: number | null;
  subCategory: number | null;
};
export type FiltersState = FilterType & FilterExtras;

interface InitialStateTypes {
  filters: FiltersState;
  isFiltersFullOpen: boolean;
}
//    coordinates: [51.531, 25.2854],
//city id:1
export const initialState: InitialStateTypes = {
  filters: {
    city_id: null,
    propertyType: null,
    category: null,
    subCategory: null,
    category_id: null,
    sale_type_id: null,
    is_direct: null,
    condition_id: null,
    rooms: null,
    toilets: null,
    min_land_area: null,
    min_price: null,
    max_price: null,
    coordinates: null,
  },
  isFiltersFullOpen: false,
};

export const FilterSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<Partial<FiltersState>>) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    toggleFiltersFullOpen: (state) => {
      state.isFiltersFullOpen = !state.isFiltersFullOpen;
    },
  },
});

export const { setFilters, toggleFiltersFullOpen } = FilterSlice.actions;

export default FilterSlice.reducer;
